import { render } from "./BenefitB.vue?vue&type=template&id=23108a36&scoped=true"
import script from "./BenefitB.vue?vue&type=script&lang=js"
export * from "./BenefitB.vue?vue&type=script&lang=js"

import "./BenefitB.vue?vue&type=style&index=0&id=23108a36&scoped=true&lang=css"

import exportComponent from "/home/runner/work/APLM/APLM/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23108a36"]])

export default __exports__